$(document).on('click', '.lang_select li a', function(e) {
    e.preventDefault();

    changeLocale($(this).data('lang'));
});

function changeLocale(locale) {
    $.ajax({
        type: 'POST',
        url: window.baseUrl + '/change-locale/' + locale,
    }).always(function() {
        window.location.reload();
    });
}
